import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { IContract, IContractApprovalConf } from '../../../contract-management/models/contract-management.model';
import { CONTRACT_STATUS, INTEGRATION_STATUS } from './badge.enums';
import { CONTRACT_APPROVAL_STATUS } from '../user-chips/user-chips.component';
import { CONTRACT_USER_ROLE } from '../../../@core/models/model';
import { getContractStatusText } from '../../../contract-management/utils';

@Component({
  selector: 'app-badge',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {

  @Input() status!: string
  @Input() text: boolean = false
  @Input() badgeType: string = 'default'

  @Input() contract!: IContract

  @Input() approver!: IContractApprovalConf
  @Input() integration!: string

  @Input() permission!: string
  badgeText: string = CONTRACT_STATUS.DRAFT

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.initialBadges();
    }
  }

  ngOnInit(): void {
    if (this.status) {
      this.getBadgeColor(this.status as CONTRACT_STATUS)
    }
    this.initialBadges();
  }

  initialBadges() {
    if (this.approver) {
      this.getBadgeColorApproval(this.approver?.status || CONTRACT_APPROVAL_STATUS.PENDING)
    }
    if (this.contract) {
      this.getBadgeColor(this.contract?.status || CONTRACT_STATUS.DRAFT)
    }
    if (this.permission) {
      this.getPermissionBadgeColor(this.permission || CONTRACT_USER_ROLE.OWNER)
    }
    if (this.integration) {
      this.getIntegrationBadgeColor(this.integration ?? INTEGRATION_STATUS.DISCONNECTED)
    }
    if (this.text) {
      this.badgeText = this.status
      this.badgeType = this.badgeType
    }
  }

  getIntegrationBadgeColor(status: string) {

    switch (status) {
      case INTEGRATION_STATUS.CONNECTED:
        this.badgeText = 'Connected'
        this.badgeType = 'success'
        break;
      case INTEGRATION_STATUS.DISCONNECTED:
        this.badgeText = 'Disconnected'
        this.badgeType = 'danger'
        break;
      default:
        this.badgeText = 'Disconnected'
        this.badgeType = 'danger'
        break;
    }
  }

  getBadgeColor(status: CONTRACT_STATUS) {
    this.badgeText = getContractStatusText(status)
    switch (status) {
      case CONTRACT_STATUS.PENDING_APPROVAL:
        this.badgeType = 'pending'
        break;
      case CONTRACT_STATUS.APPROVED:
        this.badgeType = 'success'
        break;
      case CONTRACT_STATUS.REJECTED:
        this.badgeType = 'danger'
        break;
      case CONTRACT_STATUS.SIGNATURE_IN_PROGRESS:
        this.badgeType = 'pending'
        break;
      case CONTRACT_STATUS.READY_FOR_SIGNATURE:
        this.badgeType = 'pending'
        break;
      case CONTRACT_STATUS.SIGNATURE_COMPLETED:
        this.badgeType = 'success'
        break;
      default:
        this.badgeType
        break;
    }
  }

  getBadgeColorApproval(status: string) {
    switch (status) {
      case CONTRACT_APPROVAL_STATUS.PENDING:
        this.badgeText = 'Review pending'
        this.badgeType = 'pending'
        break;
      case CONTRACT_STATUS.SIGNED:
        this.badgeText = 'Signed'
        this.badgeType = 'success'
        break;
      case CONTRACT_STATUS.APPROVED:
        this.badgeText = 'Approved'
        this.badgeType = 'success'
        break;
      case CONTRACT_STATUS.REJECTED:
        this.badgeText = 'Rejected'
        this.badgeType = 'danger'
        break;
      case CONTRACT_APPROVAL_STATUS.SKIPPED:
        this.badgeText = 'Skipped'
        this.badgeType = 'default'
        break;
      default:
        this.badgeText = 'Waiting'
        this.badgeType = 'default'
        break;
    }
  }

  getPermissionBadgeColor(permission: string) {
    switch (permission) {
      case CONTRACT_USER_ROLE.VIEWER:
        this.badgeText = 'Viewer'
        break;
      case CONTRACT_USER_ROLE.EDITOR:
        this.badgeText = 'Editor'
        break;
      case CONTRACT_USER_ROLE.COMMENTER:
        this.badgeText = 'Commenter'
        break;
      case CONTRACT_USER_ROLE.ADMIN:
        this.badgeText = 'Editor'
        break;
      default:
        this.badgeText = 'Owner'
        break;
    }
    this.badgeType = 'primary'
  }
}

